import React from "react";
import Cards from "../../components/Cards/Cards";
import PageHeader from "../../components/common/PageHeader";
import StatusToggle from "../../components/StatusToggle";

const MainDash = () => {
  // Mock status - in real app this would come from context/state management
  const [restaurantStatus, setRestaurantStatus] = React.useState("online");

  return (
    <div className="space-y-6 pb-8">
      {/* Common Header with Status Toggle */}
      <PageHeader
        showBackButton={false}
        title="Dashboard"
        subtitle="Monitor your restaurant's performance and manage operations"
        action={
          <StatusToggle
            status={restaurantStatus}
            setStatus={setRestaurantStatus}
          />
        }
      />

      {/* Stats Cards Grid */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 mb-6">
        <Cards />
      </div>
    </div>
  );
};

export default MainDash;
